import styled, { css } from 'styled-components';

export const CompletionBanner = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};

  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: ${`${theme.spacing(0.5)} ${theme.spacing(3)}`};
    `};
`;
